var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInteriorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#DEEEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3697 45.3001L45.71 38.542C44.9461 35.4288 41.8041 33.5245 38.6893 34.2881C35.5745 35.0516 33.6693 38.192 34.4332 41.3052L40.6946 66.8151C41.3357 69.4193 43.9639 71.0145 46.5694 70.3737L52.849 68.833C55.4545 68.1922 57.0506 65.5653 56.4094 62.9611L55.9502 61.0887C55.2226 58.13 53.7448 55.4122 51.6577 53.1944C49.5705 50.9765 48.0927 48.2587 47.3652 45.3001",
    fill: "#3078FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9031 63.5927L34.4329 41.3096C34.3192 40.846 34.2646 40.3825 34.2646 39.9235C34.2646 37.3147 36.038 34.9424 38.689 34.2925C41.8038 33.5289 44.9458 35.4332 45.7098 38.5464L47.3695 45.3045C47.7332 46.7815 48.2834 48.2041 49.0064 49.5311C49.7249 50.8582 50.6206 52.0899 51.6619 53.1988C53.7491 55.4166 55.2269 58.1344 55.9544 61.0931L56.4137 62.9655C56.5774 63.6336 56.5956 64.3017 56.4864 64.9425",
    fill: "#3078FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9031 63.5927L34.4329 41.3096C34.3192 40.846 34.2646 40.3825 34.2646 39.9235C34.2646 37.3147 36.038 34.9424 38.689 34.2925C41.8038 33.5289 44.9458 35.4332 45.7098 38.5464L47.3695 45.3045C47.7332 46.7815 48.2834 48.2041 49.0064 49.5311C49.7249 50.8582 50.6206 52.0899 51.6619 53.1988C53.7491 55.4166 55.2269 58.1344 55.9544 61.0931L56.4137 62.9655C56.5774 63.6336 56.5956 64.3017 56.4864 64.9425",
    stroke: "#DEEEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5706 63.9747L40.6982 66.8152L41.5349 72.0463C41.9896 74.8959 44.4496 76.991 47.337 76.991H65.3482C68.9586 76.991 71.8869 74.0642 71.8869 70.4556C71.8869 66.5425 68.4675 63.5066 64.5752 63.9702",
    fill: "#3078FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3527 63.9292C65.3527 63.9292 71.705 63.3884 71.8778 70.4646C71.9642 74.0732 68.9494 77 65.339 77H47.3279C44.6906 77 42.4124 75.2503 41.6895 72.7824",
    fill: "#3078FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3527 63.9292C65.3527 63.9292 71.705 63.3884 71.8778 70.4646C71.9642 74.0732 68.9494 77 65.339 77H47.3279C44.6906 77 42.4124 75.2503 41.6895 72.7824",
    stroke: "#DEEEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2422 66.038L64.5713 63.9746C64.835 63.9428 65.0987 63.9292 65.3534 63.9292",
    fill: "#3078FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2422 66.038L64.5713 63.9746C64.835 63.9428 65.0987 63.9292 65.3534 63.9292",
    stroke: "#DEEEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2919 17.127C31.9728 17.6951 30.5541 20.0357 31.1271 22.3535L32.5685 28.2299C33.1369 30.5477 35.4787 31.9657 37.7977 31.3976C40.1167 30.8295 41.5354 28.489 40.967 26.1711L39.5256 20.2947C38.9527 17.9723 36.6109 16.5543 34.2919 17.127Z",
    fill: "#3078FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9525 22.0488L40.962 26.1664C41.0484 26.5118 41.0893 26.8572 41.0893 27.1981C41.0893 29.1433 39.7661 30.9066 37.7972 31.3929C35.4782 31.961 33.1364 30.543 32.568 28.2252L31.1266 22.3533C30.5582 20.0355 31.9723 17.6949 34.2914 17.1268C35.9965 16.7087 37.7153 17.3632 38.7294 18.663C38.7294 18.663 39.2977 19.5401 39.4114 19.9173C39.5251 20.2945 39.9525 22.0534 39.9525 22.0534V22.0488Z",
    fill: "#3078FF",
    stroke: "#DEEEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5778 67.8425C47.5778 65.0747 45.3315 62.8296 42.5624 62.8296C39.7932 62.8296 37.5469 65.0747 37.5469 67.8425C37.5469 70.6103 39.7932 72.8554 42.5624 72.8554C45.3315 72.8554 47.5778 70.6103 47.5778 67.8425Z",
    fill: "#3078FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5778 67.8425C47.5778 65.0747 45.3315 62.8296 42.5624 62.8296C39.7932 62.8296 37.5469 65.0747 37.5469 67.8425C37.5469 70.6103 39.7932 72.8554 42.5624 72.8554C45.3315 72.8554 47.5778 70.6103 47.5778 67.8425Z",
    fill: "#3078FF",
    stroke: "#DEEEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteriorIcon);
export default __webpack_public_path__ + "static/media/interior-icon.dfaa08a31c1a4c9f6866de84e502ab9c.svg";
export { ForwardRef as ReactComponent };